import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";

import type {
  FareSearchPayload,
  FareSearchResponse,
  AvailableDatesPayload,
  AvailableDatesResponse,
} from "../types/fare-search.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.inventory;

export const fareSearchService = {
  // departure dates (with lowest fare and seats) that have inventory for a route
  async availableDates(payload: AvailableDatesPayload): Promise<AvailableDatesResponse> {
    try {
      return await apiClient<AvailableDatesResponse>(endpoints.dateAvailablity, {
        method: "POST",
        body: JSON.stringify(payload),
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to load available dates.",
        resData: [],
      };
    }
  },

  async search(payload: FareSearchPayload): Promise<FareSearchResponse> {
    try {
      return await apiClient<FareSearchResponse>(endpoints.fareSearch, {
        method: "POST",
        body: JSON.stringify(payload),
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to search fares due to an unexpected error.",
        resData: null,
      };
    }
  },
};
